import { render, staticRenderFns } from "./PdfContent.vue?vue&type=template&id=04bb457e&scoped=true&lang=pug&"
import script from "./PdfContent.vue?vue&type=script&lang=ts&"
export * from "./PdfContent.vue?vue&type=script&lang=ts&"
import style0 from "./PdfContent.vue?vue&type=style&index=0&id=04bb457e&prod&lang=stylus&scoped=true&"
import style1 from "./PdfContent.vue?vue&type=style&index=1&id=04bb457e&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb457e",
  null
  
)

export default component.exports